
import { Container } from "react-bootstrap";
import { withRouter } from "react-router-dom";
import '../assets/css/geral.scss';
import WorldMap from "./WorldMap";



function CreateMap(props) {

	function getMap() {
		const region = props.region;
		if (region === "NORAM") {
			return getNoramMap();
		} else if (region === "LATAM") {
			return getLatamMap();
		} else if (region === "EMEA") {
			return getEmeaMap();
		} else if (region === "APAC") {
			return getApacMap();
		} else {
			return <WorldMap width={props.width} />;
		}
	}

	function getApacMap() {
		return <Container className="mt-5">
			<svg
				xmlns="http://www.w3.org/2000/svg"
				viewBox="610 270 400 340"
				aria-label="APAC"
				width={props.width}>
				{props.apac}
				<g font-size="13" font-family="sans-serif" fill="white" stroke="none" text-anchor="middle">
					{/* black */}
					<text x="810" y="480" >Indonesia</text>

				</g>
				<g font-size="10" font-family="sans-serif" fill="white" stroke="none" text-anchor="middle">
					{/* black */}
					<text x="760" y="320" >Mongolia</text>
					<text x="760" y="360" >China</text>
					<text x="695" y="405" >India</text>
					<text x="823" y="360" >South</text>
					<text x="823" y="367" >Korea</text>
					<text x="860" y="350" >Japan</text>
					<text x="780" y="457" >Malaysia</text>
					<text x="843" y="423" >Philippines</text>
					<text x="914" y="479" >Papua</text>
					<text x="918" y="487" >New Guinea</text>
					<text x="960" y="575" >New Zealand</text>
				</g>
				<g font-size="6" font-family="sans-serif" fill="white" stroke="none" text-anchor="middle">
					{/* black */}
					<text x="773" y="443" >Cambodia</text>
					<text x="793" y="423" >Vietnam</text>
					<text x="780" y="465" >Singapore</text>
				</g>
				<g font-size="10" font-family="sans-serif" fill="white" stroke="none" text-anchor="middle">
					<text x="850" y="535" >Australia</text>
				</g>
				<g font-size="6" font-family="sans-serif" fill="white" stroke="none" text-anchor="middle">
					<text x="660" y="380" >Pakistan</text>
					<text x="712" y="380" >Nepal</text>
					<text x="735" y="380" >Bhutan</text>
					<text x="715" y="395" >Bangladesh</text>
					<text x="745" y="400" >Myanmar</text>
					<text x="759" y="420" >Thailand</text>

				</g>
			</svg>
		</Container>;
	}

	function getEmeaMap() {
		return <Container className="mt-5">
			<svg
				// className="dark-mode"
				xmlns="http://www.w3.org/2000/svg"
				viewBox="400 200 250 220"
				aria-label="Europe Africa and Middle East"
				width={props.width}>
				{props.emea}
				<g font-size="5" font-family="sans-serif" fill="white" stroke="none" text-anchor="middle">
					{/* <text x="440" y="340">Portugal</text> */}
					{/* <text x="465" y="340">Spain</text> */}
					{/* <text x="470" y="290">UK</text> */}
					{/* <text x="440" y="290">Ireland</text> */}
					{/* black */}
					<text x="570" y="345">Turkey</text>
					<text x="595" y="365">Iraq</text>
					<text x="595" y="390">Saudi Arabia</text>
					<text x="555" y="390">Egypt</text>
					<text x="420" y="390">Western</text>
					<text x="420" y="394">Sahara</text>
					{/* <text x="487" y="275">Denmark</text> */}
				</g>
				<g font-size="3" font-family="sans-serif" fill="white" stroke="none" text-anchor="middle">
					{/* black */}
					<text x="537" y="345">Greece</text>
					<text x="580" y="370">Jordan</text>
					<text x="511" y="360">Tunisia</text>
					<text x="630" y="390">United Arab</text>
					<text x="630" y="393">Emirates</text>
					<text x="630" y="410">Oman</text>
					<text x="595" y="333">Georgia</text>
					<text x="598" y="343">Armenia</text>
					<text x="615" y="340">Azerbaijan</text>
					<text x="560" y="360">Cyprus</text>
					<text x="569" y="363">Lebanon</text>
					<text x="568" y="368">Israel</text>
				</g>
				<g font-size="5" font-family="sans-serif" fill="white" stroke="none" text-anchor="middle">
					{/* <text x="482" y="315">France</text> */}
					{/* <text x="424" y="225">Iceland</text> */}
					{/* <text x="547" y="240">Finland</text> */}
					{/* <text x="500" y="250">Norway</text> */}
					{/* <text x="516" y="254">Sweden</text> */}
					<text x="580" y="270">Russia</text>
					<text x="552" y="290">Belarus</text>
					<text x="560" y="305">Ukraine</text>
					<text x="528" y="290">Poland</text>
					{/* <text x="505" y="295">Germany</text> */}
					<text x="525" y="385">Libya</text>
					<text x="480" y="385">Algeria</text>
					<text x="460" y="370">Morocco</text>

				</g>
				<g font-size="3" font-family="sans-serif" fill="white" stroke="none" text-anchor="middle">
					<text x="548" y="260">EST.</text>
					<text x="548" y="270">LAT.</text>
					<text x="540" y="277">LITH.</text>
					<text x="518" y="303">CZ REP.</text>
					<text x="530" y="307">Slovakia</text>
					<text x="528" y="315">Hungary</text>
					{/* <text x="515" y="313">Austria</text> */}
					<text x="545" y="320">Romania</text>
					<text x="546" y="332">Bulgaria</text>
					{/* <text x="502" y="322">Italy</text> */}
				</g>
				<g font-size="2" font-family="sans-serif" fill="white" stroke="none" text-anchor="middle">
					{/* <text x="498" y="315">Switzerland</text>		 */}
					<text x="523" y="321">Croacia</text>
					<text x="517" y="318">Slovenia</text>
					<text x="533" y="325">Serbia</text>
					<text x="535" y="332">Kosovo</text>
					<text x="538" y="336">Macedonia</text>
					<text x="524" y="325">Bosnia &</text>
					<text x="527" y="328">Herzegovina</text>

				</g>
				<g font-size="2" font-family="sans-serif" fill="white" stroke="none" text-anchor="middle">
					{/* black */}
					<text x="526" y="336">Albania</text>
					<text x="522" y="333">Montenegro</text>
				</g>
			</svg>
		</Container>;
	}
	function getNoramMap() {
		return <Container><svg xmlns="http://www.w3.org/2000/svg" viewBox="-100 680 793 350" aria-label="Map of Canada" width={props.width} >
			{props.canada}
			<g font-size="13" font-family="sans-serif" fill="white" stroke="none" text-anchor="middle">
				<text x="320" y="840">SK</text>
				<text x="220" y="840">AB</text>
				<text x="130" y="840">BC</text>
				<text x="400" y="840">MB</text>
				<text x="480" y="900">ON</text>
				<text x="620" y="900">QC</text>
				<text x="700" y="870">NL</text>
				<text x="-5" y="840" >AK</text>

			</g>
		</svg>
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="8 6 920 585" aria-label="Map of USA States and Territories" width={props.width}>
				{props.usa}
				<g font-size="13" font-family="sans-serif" fill="white" stroke="none" text-anchor="middle">
					<text x="80" y="310" >CA</text>
					<text x="80" y="130" >OR</text>
					<text x="100" y="60" >WA</text>
					<text x="200" y="160" >ID</text>
					<text x="300" y="100">MT</text>
					<text x="400" y="100">ND</text>
					<text x="400" y="170">SD</text>
					<text x="420" y="230">NE</text>
					<text x="500" y="150">MN</text>
					<text x="520" y="220">IA</text>
					<text x="600" y="250">IL</text>
					<text x="580" y="170">WI</text>
					<text x="660" y="180">MI</text>
					<text x="700" y="250">OH</text>
					<text x="640" y="250">IN</text>
					<text x="780" y="220">PA</text>
					<text x="800" y="170">NY</text>
					<text x="845" y="130">VT</text>
					<text x="865" y="140">NH</text>
					<text x="890" y="90">ME</text>
					<text x="680" y="300">KY</text>
					<text x="650" y="350">TN</text>
					<text x="600" y="420">MS</text>
					<text x="650" y="410">AL</text>
					<text x="720" y="410">GA</text>
					<text x="760" y="380">SC</text>
					<text x="780" y="330">NC</text>
					<text x="780" y="290">VA</text>
					<text x="730" y="290">WV</text>
					<text x="545" y="460">LA</text>
					<text x="760" y="500">FL</text>
					<text x="300" y="200">WY</text>
					<text x="320" y="280">CO</text>
					<text x="300" y="380">NM</text>
					<text x="200" y="380">AZ</text>
					<text x="220" y="250">UT</text>
					<text x="130" y="230">NV</text>
					<text x="450" y="370" >OK</text>
					<text x="450" y="300" >KS</text>
					<text x="400" y="450" >TX</text>
					<text x="540" y="300" >MO</text>
					<text x="540" y="370" >AR</text>
				</g>
			</svg></Container>;
	}

	function getLatamMap() {
		return <svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="140 330 310 320"
			aria-label="South America"
			width={props.width}>
			{props.latam}
			<g font-size="6" font-family="sans-serif" fill="white" stroke="none" text-anchor="middle">
				{/* black */}
				<text x="287" y="442" >Venezuela</text>
				<text x="272" y="453" >Colombia</text>
				<text x="261" y="488" >Peru</text>
				<text x="293" y="514" >Bolivia</text>
				<text x="297" y="550" >Argentina</text>
				<text x="185" y="391" >Mexico</text>
				<text x="266" y="563" >Chile</text>
				<text x="330" y="495" >Brasil</text>
			</g>
			<g font-size="4" font-family="sans-serif" fill="white" stroke="none" text-anchor="middle">
				{/* black */}
				<text x="234" y="413" >Belize</text>
				<text x="217" y="428" >El Salvador</text>
				<text x="216" y="408" >Guatemala</text>
				<text x="245" y="428" >Nicaragua</text>
				<text x="239" y="417" >Honduras</text>
				<text x="227" y="440" >Costa Rica</text>
				<text x="248" y="446" >Panama</text>
				<text x="248" y="466" >Equador</text>
				<text x="310" y="529" >Paraguay</text>
				<text x="325" y="563" >Uruguay</text>
				<text x="260" y="417" >Jamaica</text>
				<text x="290" y="403" >Dominican Republic</text>
				<text x="290" y="417" >Puerto Rico</text>
			</g>
		</svg>;
	}

	return (
		<Container>{getMap()}</Container>
	)
}

export default withRouter(CreateMap);



